import styled, { css } from 'styled-components';
import { Row } from 'components/layout';
import { ReactComponent as _DeleteIcon } from 'styles/icons/delete-icon.svg';
import { ReactComponent as _SideDrawerIcon } from './icons/side-drawer-icon.svg';
import { color } from 'styles/settings';
import { withModifiers } from 'utils/styles';

const iconStyle = css`
  height: 24px;
  width: 24px;
  color: ${color.neutral.plainBlack};
  cursor: pointer;
`;

export const Menu = styled(Row).attrs({ spaceBetween: true })`
  align-items: center;
  background-color: ${color.neutral.white};
  box-shadow: 5px 5px rgba(229, 229, 229, 0.3);
  padding: 4px;
  position: relative;
  height: 50px;
  padding-right: 20px;

  ${withModifiers('scale')`
    transform: scale(${({ scale }) => scale.toString()});
  `};

  ${withModifiers('position')`
    position: fixed;
    left: ${({ position }) => position.x}px;
    top: ${({ position }) => position.y}px;
    transform-origin:top left;
  `}
`;

export const SideDrawerIcon = styled(_SideDrawerIcon)`
  ${iconStyle};
  margin-left: 20px;
  margin-right: 16px;
`;

export const DeleteIcon = styled(_DeleteIcon)`
  ${iconStyle};
  :hover {
    color: ${color.ui.danger};
  }
`;

export const DeleteIconContainer = styled.div`
  margin-left: 20px;
  padding-left: 20px;
  padding-right: 10px;
  border-left: 2px solid ${color.neutral.grayLight};
  height: 50px;
  display: flex;
  align-items: center;
`;
